import '../../css/blocks/servicesoverview.css';

// Wait for the window to fully load before initializing
window.addEventListener('load', () => {
  const servicesoverviewBlocks = document.querySelectorAll('.servicesoverview');
  
  if (servicesoverviewBlocks.length) {
    // Initialize block-specific functionality here
  }
});
